<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>

<script>
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
import en_US from 'ant-design-vue/lib/locale-provider/en_US';
import { getMenu,getUserInfo } from "@/api/user";
import { toTree } from "@/utils/index";
import { resetRouter } from "@/router/index";
import { addLayout, filterAsyncRouter } from "@/utils/permission";
// import moment from 'moment';
// import 'moment/locale/zh-cn';
// import i18n from "@/lang";
//   moment.locale('zh-cn');
export default {
  name: "App",
  data() {
    return {
      // zh_CN,
      // en_US
    };
  },
  methods: {
    // 根据用户id获取菜单
    getMenu(usid) {

      getMenu(usid)
        .then((res) => {
          // this.$message.success("登录成功");
          let menus = toTree(res.data).children;
          this.$store.commit("user/SET_MENUS", menus);
          menus = addLayout(menus);
          const saveMenuData = filterAsyncRouter(menus);
          resetRouter();
          this.$router.addRoutes(saveMenuData);
          // let path = "";
          // this.$router.push({
          //   path: "/DashBoard",
          // });
        })
        .catch((error) => {
        });
    },
   async getUserInfo(){
     return getUserInfo(["获取登录信息"]).then(res=>{
        console.log(res);
      })
    },
  },
  computed: {
    locale() {
      return this.$i18n.locale === 'zh' ? zh_CN : en_US
    },
  },
  created() {
  },
 async mounted(){
      // await  this.getUserInfo();
    if (!(this.$route.path == "/login" || this.$route.path == "/" || this.$route.path == "/bigScreen")) {
      this.menu = this.$store.state.menu;
      if (this.$store.state.user.usid) {
        this.getMenu(this.$store.state.user.usid)
      } else {
        this.$router.push({
          name: 'Login'
        });
      }
    }
    if(this.$store.state.user.dataTheme){
      document.documentElement.setAttribute('data-theme',this.$store.state.user.dataTheme)
    }else{
      document.documentElement.setAttribute('data-theme','blue')
    }
  }
};
</script>
<style lang="scss">
/** 弹性盒布局 **/
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
